/**
 * Join codes are read off a big screen and typed on a phone, so the alphabet
 * excludes characters that are easily confused: I, O, 0 and 1 (§4 Join code).
 *
 * Generation lives in the API package — this module stays browser-safe so the
 * taker's code-entry form can validate input before hitting the network.
 */

export const JOIN_CODE_ALPHABET = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
export const JOIN_CODE_LENGTH = 6;

const JOIN_CODE_PATTERN = new RegExp(`^[${JOIN_CODE_ALPHABET}]{${JOIN_CODE_LENGTH}}$`);

export function isValidJoinCode(value: string): boolean {
  return JOIN_CODE_PATTERN.test(value);
}

/**
 * Prepares typed input for comparison: strips separators and case. Characters
 * outside the alphabet are preserved so that validation rejects them rather
 * than silently matching a different quiz.
 */
export function normalizeJoinCode(input: string): string {
  return input
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '');
}
